import {useI18n} from '@udemy/i18n';
import {AlertBanner} from '@udemy/react-messaging-components';

import {useRootStore} from '../../contexts/root-store-context';
import {PaymentMethodType, PayoutStatusType, usePayoutExistsQuery} from '../../generated/graphql';
import styles from './section.module.less';

export const HelperLinksSection = () => {
    const {gettext} = useI18n();

    const tipaltiPayoutExistQuery = usePayoutExistsQuery({
        filter: {
            statuses: [PayoutStatusType.Success, PayoutStatusType.Processing],
            payoutMethods: [PaymentMethodType.Tipalti],
        },
    });

    const rootStore = useRootStore();

    const getContent = () => {
        const tipaltiPayoutExist = tipaltiPayoutExistQuery.data?.payoutExists ?? false;

        return (
            <AlertBanner
                showCta={false}
                className={styles['alert-panel']}
                title={gettext('Stay informed about your payouts.')}
                body={
                    <>
                        {tipaltiPayoutExist && rootStore.tipaltiPaymentsHistoryLink && (
                            <p>
                                {gettext('View the status of your Tipalti payments ')}
                                <a
                                    className={styles['link-style']}
                                    href={rootStore.tipaltiPaymentsHistoryLink}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    {gettext('here')}
                                </a>
                                .
                            </p>
                        )}
                        <p>
                            {gettext('Learn more about')}&nbsp;
                            <a
                                className={styles['link-style']}
                                href="https://support.udemy.com/hc/articles/229604008"
                            >
                                {gettext('our payout process')}
                            </a>
                        </p>
                        <p>
                            {gettext('In case you have not received your payout')}&nbsp;
                            <a
                                className={styles['link-style']}
                                href="https://support.udemy.com/hc/articles/229232327"
                            >
                                {gettext('troubleshooting steps')}
                            </a>
                        </p>
                    </>
                }
            />
        );
    };

    return <div className={styles['section-container']}>{getContent()}</div>;
};
